import { Pagination, Result } from 'antd'
import { useRouter } from 'next/router'
import NewsLayout from 'src/components/Layout/NewsLayout'
import PostNewsList from 'src/components/PostNewsList'
import { SEO } from 'src/components/SEO'
import BASE_CONFIG from 'src/configs/base'
import newsServices from 'src/services/news.service'

function ArticleByCategory({ news, totalRecord, currentPage, categorySlug }) {
	const router = useRouter()
	const { pinPost } = newsServices.usePinPost()

	const handlePageChange = (p) => {
		router.push({
			pathname: router.pathname,
			query: {
				page_index: p,
				categorySlug,
			},
		})
	}

	return (
		<div className="article__page">
			<SEO
				data={{
					title: `Tin tức | ${BASE_CONFIG.SLOGAN}`,
					url: BASE_CONFIG.PAGE_URL + useRouter().asPath,
				}}
			/>
			<div className="container">
				{news?.length > 0 ? (
					<>
						<div className="article__page-news">
							<PostNewsList leftNews={news} hotNews={pinPost} />
						</div>
						<div className="article__page-pagination">
							<Pagination
								onChange={handlePageChange}
								showSizeChanger={false}
								defaultCurrent={currentPage}
								pageSize={6}
								total={totalRecord}
							/>
						</div>
					</>
				) : (
					<Result
						title={
							<h4 style={{ color: 'var(--my-red)', margin: 0, opacity: 0.6, fontWeight: 500 }}>
								404! Không tìm thấy bài viết
							</h4>
						}
						// eslint-disable-next-line @next/next/no-img-element
						icon={<img style={{ maxWidth: '90%', height: 250 }} src="/images/404.jpg" alt="404" />}
					/>
				)}
			</div>
		</div>
	)
}

export const getServerSideProps = async ({ params, query }) => {
	const { page_index } = query
	const response = await newsServices.getNews({
		categorySlug: params.categorySlug,
		pageIndex: Number(page_index),
	})

	return {
		props: {
			news: response.Data,
			totalRecord: response.TotalRecord,
			currentPage: Number(page_index) || 1,
			categorySlug: params.categorySlug,
		},
	}
}

ArticleByCategory.Layout = NewsLayout
export default ArticleByCategory
